import React from "react";

interface IconIProps {
  size?: string;
}

const DatePickerIcon = ({ size = "14" }: IconIProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.74998 1.75V4.08333M5.24998 1.75V4.08333M2.33331 6.41667H11.6666M11.6666 6.41667V11.0833C11.6666 11.7277 11.1443 12.25 10.5 12.25H3.49998C2.85565 12.25 2.33331 11.7277 2.33331 11.0833V4.08333C2.33331 3.439 2.85565 2.91667 3.49998 2.91667H10.5C11.1443 2.91667 11.6666 3.439 11.6666 4.08333V6.41667Z"
        stroke="#4D5965"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default DatePickerIcon;
